/* global axios */
import ApiClient from './ApiClient';

// Painel de Gestão Operacional — 5 endpoints do Api::V2::Accounts::OperationsController.
// `since`/`until` são epoch em SEGUNDOS (DateRangeHelper faz strptime '%s'); sem
// eles o backend recorta o dia atual (modo Tempo Real).
class OperationsAPI extends ApiClient {
  constructor() {
    super('operations', { accountScoped: true, apiVersion: 'v2' });
  }

  overview(params = {}) {
    return axios.get(`${this.url}/overview`, { params });
  }

  // Se o período vai ser contado na fonte (lento) — barato, pedido em paralelo.
  coverage(params = {}) {
    return axios.get(`${this.url}/coverage`, { params });
  }

  ai(params = {}) {
    return axios.get(`${this.url}/ai`, { params });
  }

  channels(params = {}) {
    return axios.get(`${this.url}/channels`, { params });
  }

  teams(params = {}) {
    return axios.get(`${this.url}/teams`, { params });
  }

  queue(params = {}) {
    return axios.get(`${this.url}/queue`, { params });
  }

  // Detalhe por agente de UM time (drawer do card). `team_id` obrigatório;
  // since/until seguem a mesma convenção dos demais.
  teamAgents(params = {}) {
    return axios.get(`${this.url}/team_agents`, { params });
  }
}

export default new OperationsAPI();
